"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchPageFilterDictionary = exports.searchPageDictionary = void 0;
exports.searchPageDictionary = {
    applyBtnLabel: 'Filter - Apply',
    cancelBtnLabel: 'Filter - Cancel',
    closeBtnLabel: 'Filter - Close',
    doneBtnLabel: 'Filter - Done',
    resetBtnLabel: 'Filter - Clear Filters',
    filterBtnLabel: 'Filter - Filter',
    filterHeaderDefaultLabel: 'Filter - Filter by',
    updated: 'Search Results - Updated',
    multilanguage: 'Search Results - Multilanguage',
    searchResultsFor: 'Search Results - Search Results For',
    numberOfItems: 'Search Results - Results',
    searchInResultsPlaceholder: 'Search Results - Search in results',
    validForLabel: 'Valid for - Label',
    multipleLabel: 'Valid for - Multiple label',
    multipleTooltipMessage: 'Valid for - Multiple tooltip message',
    globalTooltipMessage: 'Valid for - Global tooltip message',
    validForAllCountries: 'Valid for - All countries/cities',
    paginationRows: 'Rows Per Page',
    paginationToPage: 'Go To Page',
    paginationNext: 'Next',
    paginationPrevious: 'Previous',
    searchButton: 'Search',
    paginationPage: 'Page',
    paginationPageOf: 'of',
    communicationErrorMessage: 'Communication Error Message',
    showMoreBtnLabel: 'Show more',
    showLessBtnLabel: 'Show less',
};
exports.searchPageFilterDictionary = {
    // Segments
    ['Business unit']: 'FilterSegment - Label',
    ['DCS']: 'FilterSegment - Climate Solutions for cooling',
    ['DPS']: 'FilterSegment - Power Solutions',
    ['DPD']: 'FilterSegment - Drives',
    // Hierarchy levels
    ['Product group']: 'Search Results - Product Group',
    ['Product series']: 'Search Results - Product Series',
    ['Product hierarchy']: 'Search Results - Product hierarchy - Label',
    // Pages
    ['Page types']: 'FilterPages - Label',
    ['home']: 'FilterPages - Home',
    ['productCategory']: 'FilterPages - Category',
    ['productCategoryArea']: 'FilterPages - Category area',
    ['productSubCategory']: 'FilterPages - Sub category',
    ['productType']: 'FilterPages - Product',
    // Labels
    ['Document types']: 'FilterLabel - Document types',
    ['Drawing types']: 'FilterLabel - Drawing types',
    ['Software types']: 'FilterLabel - Software types',
    ['All countries/regions']: 'FilterLabel - Country',
    ['All languages']: 'FilterLabel - Language',
    // Status
    ['Status']: 'FilterStatus - Label',
    ['Archived']: 'FilterStatus - Archived',
    ['Published']: 'FilterStatus - Published',
    // Hierarchy levels
    ['Level 1']: 'HierarchyFilterLevels - Level 1',
    ['Level 2']: 'HierarchyFilterLevels - Level 2',
    ['Level 3']: 'HierarchyFilterLevels - Level 3',
    ['Level 4']: 'HierarchyFilterLevels - Level 4',
    ['Level 5']: 'HierarchyFilterLevels - Level 5',
    ['Level 6']: 'HierarchyFilterLevels - Level 6',
    ['Valid for']: 'Valid for - Label',
};
